/* eslint-disable indent */
import React from 'react'
import styled from '@emotion/styled'
import { Text } from '../../styles/Components'

const PaymentMethodImage = styled.img`
  max-height: 22px;
`
const PaymentMethodDetailsWrapper = styled.div`
  margin-left: 12px;
  display: flex;
  gap: 6px;
`

const getBrandImage = ({ brand }) => {
  let brandImageSrc

  switch (brand) {
    case 'Visa':
      brandImageSrc = '/images/visa-card.svg'
      break
    case 'MasterCard':
      brandImageSrc = '/images/mastercard-card.svg'
      break
    case 'American Express':
      brandImageSrc = '/images/amex-card.svg'
      break
    case 'Discover':
      brandImageSrc = '/images/discover-card.svg'
      break
    case 'Diners Club':
      brandImageSrc = '/images/diners-card.svg'
      break
    case 'JCB':
      brandImageSrc = '/images/jcb-card.svg'
      break
    case 'UnionPay':
      brandImageSrc = '/images/unionpay-card.svg'
      break
    default:
      break
  }

  if (!brandImageSrc) {
    return null
  }

  return <PaymentMethodImage src={brandImageSrc} alt={brand} />
}

const PaymentMethodDetails = ({ method }) => {
  return (
    <>
      {method && (
        <div>
          {getBrandImage(method)}
          <PaymentMethodDetailsWrapper>
            <Text fontSize={18}>{method.brand}</Text>
            <Text fontSize={18}>-</Text>
            <Text fontSize={18}>{method.number}</Text>
          </PaymentMethodDetailsWrapper>
        </div>
      )}
    </>
  )
}

export default PaymentMethodDetails
